/**
 * Centralized "Assigned To" Lookup Mapping:
 * - Info ➔ Ashok
 * - Cvitp ➔ Manjula
 * - Volunteer ➔ Divya
 * - Madhu ➔ Madhu
 * - Admin ➔ Admin
 */

export const ASSIGNEE_LOOKUP = {
  'info': 'Ashok',
  'info@orientalbiz.ca': 'Ashok',
  'ashok': 'Ashok',

  'cvitp': 'Manjula',
  'cvitp@orientalbiz.ca': 'Manjula',
  'manjula': 'Manjula',

  'volunteer': 'Divya',
  'volunteer@orientalbiz.ca': 'Divya',
  'divya': 'Divya',

  'madhu': 'Madhu',
  'madhu@orientalbiz.ca': 'Madhu',

  'admin': 'Admin',
  'admin@orientalbiz.ca': 'Admin',
};

export const ASSIGNEE_AVATAR_GRADIENTS = {
  'Ashok': 'linear-gradient(135deg, #2563eb, #1d4ed8)',
  'Manjula': 'linear-gradient(135deg, #7c3aed, #6d28d9)',
  'Divya': 'linear-gradient(135deg, #0d9488, #0f766e)',
  'Madhu': 'linear-gradient(135deg, #ea580c, #c2410c)',
  'Admin': 'linear-gradient(135deg, #475569, #334155)',
  'Unassigned': 'linear-gradient(135deg, #94a3b8, #64748b)',
};

/**
 * Returns the human-readable display name for an assignee handle/email.
 * e.g. "info@orientalbiz.ca" ➔ "Ashok"
 *      "cvitp" ➔ "Manjula"
 *      "volunteer" ➔ "Divya"
 */
export const getAssigneeDisplayName = (raw) => {
  if (!raw || typeof raw !== 'string' || !raw.trim()) {
    return 'Unassigned';
  }
  const clean = raw.trim();
  const lower = clean.toLowerCase();

  if (ASSIGNEE_LOOKUP[lower]) {
    return ASSIGNEE_LOOKUP[lower];
  }

  if (lower.includes('@')) {
    const userPart = lower.split('@')[0];
    if (ASSIGNEE_LOOKUP[userPart]) {
      return ASSIGNEE_LOOKUP[userPart];
    }
    return userPart.charAt(0).toUpperCase() + userPart.slice(1);
  }

  return clean.charAt(0).toUpperCase() + clean.slice(1);
};

/**
 * Returns gradient for the assignee avatar based on their mapped display name.
 */
export const getAssigneeAvatarGradient = (raw) => {
  const name = getAssigneeDisplayName(raw);
  return ASSIGNEE_AVATAR_GRADIENTS[name] || 'linear-gradient(135deg, #3b82f6, #1d4ed8)';
};
